import _ from 'lodash';

import GridView from '@/views/GridView';
import StringCell from '@/backgrid/StringCell';
import ButtonCell from '@/backgrid/ButtonCell';
import PageableCollection from '@/backbone/PageableCollection';
import showModal from '@/util/showModal';
import downloadCSV from '@/util/downloadCSV';
import DeliveryScheduleModalView from '@/views/DeliveryScheduleModalView';
import showErrorMessage from '@/util/showErrorMessage';

import HorizontalAddressCell from '../../../common/views/HorizontalAddressCell.js';

const RelocationDeliveryScheduleGridView = GridView.extend({
  className: 'relocation-delivery-schedule-grid-view',

  childEvents: {
    'next:clicked': 'onNextClicked',
    'previous:clicked': 'onPreviousClicked'
  },

  initialize() {
    const self = this;
    this.options.columns = [
      {
        name: 'equipmentName',
        label: 'Equipment',
        cell: StringCell,
        headerCell: 'custom',
        width: 30,
        editable: false
      },
      {
        name: 'address',
        label: 'Address',
        cell: HorizontalAddressCell,
        headerCell: 'custom',
        width: 35,
        editable: false,
        sortable: true
      },
      {
        name: 'deliveryPOCName',
        label: 'Delivery POC',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'itPOCName',
        label: 'IT POC',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'editViewButton',
        label: '',
        width: 7,
        headerCell: 'custom',
        cell: ButtonCell.extend({
          name() {
            if (self.options.editable) {
              return 'Edit';
            }
            return 'View';
          },
          onClick(e, model) {
            self.options.editable ? self.onClickEdit(e, model) : self.onClickView(e, model);
          },
          buttonClass: 'btn-sm btn-outline-primary text-center'
        }),
        editable: false,
        sortable: false
      },
      {
        name: 'organization',
        label: 'orgUnit',
        cell: StringCell,
        headerCell: 'custom',
        renderable: false
      },
      {
        name: 'base',
        label: 'base',
        cell: StringCell,
        headerCell: 'custom',
        renderable: false
      },
      {
        name: 'address1',
        label: 'address1',
        cell: StringCell,
        headerCell: 'custom',
        renderable: false
      },
      {
        name: 'address2',
        label: 'address2',
        cell: StringCell,
        headerCell: 'custom',
        renderable: false
      },
      {
        name: 'buildingFloorNumber',
        label: 'buildingFloorNumber',
        cell: StringCell,
        headerCell: 'custom',
        renderable: false
      },
      {
        name: 'roomPoleNumber',
        label: 'roomPoleNumber',
        cell: StringCell,
        headerCell: 'custom',
        renderable: false
      },
      {
        name: 'floorNumber',
        label: 'floorNumber',
        cell: StringCell,
        headerCell: 'custom',
        renderable: false
      },
      {
        name: 'city',
        label: 'city',
        cell: StringCell,
        headerCell: 'custom',
        renderable: false
      },
      {
        name: 'state',
        label: 'state',
        cell: StringCell,
        headerCell: 'custom',
        renderable: false
      },
      {
        name: 'zip',
        label: 'zip',
        cell: StringCell,
        headerCell: 'custom',
        renderable: false
      },
      {
        name: 'deliveryPOCName',
        label: 'deliveryPOCName',
        cell: StringCell,
        headerCell: 'custom',
        renderable: false
      },
      {
        name: 'deliveryPOCEmail',
        label: 'deliveryPOCEmail',
        cell: StringCell,
        headerCell: 'custom',
        renderable: false
      },
      {
        name: 'deliveryPOCPhone',
        label: 'deliveryPOCPhone',
        cell: StringCell,
        headerCell: 'custom',
        renderable: false
      },
      {
        name: 'itPOCName',
        label: 'itPOCName',
        cell: StringCell,
        headerCell: 'custom',
        renderable: false
      },
      {
        name: 'itPOCEmail',
        label: 'itPOCEmail',
        cell: StringCell,
        headerCell: 'custom',
        renderable: false
      },
      {
        name: 'itPOCPhone',
        label: 'itPOCPhone',
        cell: StringCell,
        headerCell: 'custom',
        renderable: false
      },
      {
        name: 'organization',
        label: 'organization',
        cell: StringCell,
        headerCell: 'custom',
        renderable: false
      },
      {
        name: 'base',
        label: 'base',
        cell: StringCell,
        headerCell: 'custom',
        renderable: false
      }
    ];

    this.options.collection = new PageableCollection(this.model.get('schedules'));

    this.options.emptyText = 'No Devices Selected';
  },

  async saveRowItem(modalData, model) {
    const region = _.find(this.model.get('regions'), (x) => {
      return x.id === modalData.formData.address.regionId;
    });
    modalData.formData.address.regionName = region?.name;
    modalData.formData.address.regionCode = region?.code;

    this.cleanFormData(modalData.formData);

    // Set row model data in ui
    model.set('address', modalData.formData.address);
    model.set('deliveryPOCName', modalData.formData.deliveryPOCName);
    model.set('deliveryPOCEmail', modalData.formData.deliveryPOCEmail);
    model.set('deliveryPOCPhone', modalData.formData.deliveryPOCPhone);
    const deliveryNames = model.get('deliveryPOCName')?.split(' ');
    if (deliveryNames) {
      const deliveryPOCGivenNames = deliveryNames
        .slice(0, deliveryNames.length <= 2 ? 1 : deliveryNames.length - 1)
        .join(' ');
      const deliveryPOCLastName = deliveryNames
        .slice(deliveryNames.length > 1 ? deliveryNames.length - 1 : deliveryNames.length)
        .join(' ');
      model.set('deliveryPOCFirstName', deliveryPOCGivenNames);
      model.set('deliveryPOCLastName', deliveryPOCLastName);
    }
    if (this.options.itPOCExists) {
      model.set('itPOCName', modalData.formData.itPOCName);
      model.set('itPOCEmail', modalData.formData.itPOCEmail);
      model.set('itPOCPhone', modalData.formData.itPOCPhone);
      const itNames = model.get('itPOCName').split(' ');
      const itPOCGivenNames = itNames.slice(0, itNames.length <= 2 ? 1 : itNames.length - 1).join(' ');
      const itPOCLastName = itNames.slice(itNames.length > 1 ? itNames.length - 1 : itNames.length).join(' ');
      model.set('itPOCFirstName', itPOCGivenNames);
      model.set('itPOCLastName', itPOCLastName);
    }
    model.set('organization', modalData.formData.address.organization);
    model.set('base', modalData.formData.address.base);

    this.trigger('row:item:save');
  },

  async onClickEdit(e, model) {
    if (e?.type) {
      e.preventDefault();
    }
    model.set('regions', this.model.get('regions'));
    model.set('conusOconusRegions', this.model.get('conusOconusRegions'));

    const modalData = await showModal({
      title: 'Delivery Schedule Details',
      view: new DeliveryScheduleModalView({
        isRelocationOrder: true,
        isReadOnly: false,
        itPOCExists: !!this.options.itPOCExists,
        baseOrg: true,
        model
      }),
      dialogClasses: 'modal-lg'
    });
    this.saveRowItem(modalData, model);
  },

  async onClickView(e, model) {
    if (e?.type) {
      e.preventDefault();
    }
    model.set('regions', this.model.get('regions'));
    model.set('conusOconusRegions', this.model.get('conusOconusRegions'));

    await showModal({
      title: 'Delivery Schedule Details',
      view: new DeliveryScheduleModalView({
        isRelocationOrder: true,
        isReadOnly: true,
        itPOCExists: !!this.options.itPOCExists,
        baseOrg: true,
        model
      }),
      dialogClasses: 'modal-lg'
    });
  },

  async downloadCSV() {
    try {
      const data = this.options.collection.fullCollection.toJSON();

      const columnsToInclude = ['equipmentName', 'address', 'deliveryPOCName', 'itPOCName'];
      const columnsNames = ['Equipment Name', 'Address', 'Delivery POC', 'IT POC'];

      if (this.options.itPOCExists) {
        columnsToInclude.push('itPOCName');
        columnsNames.push('IT POC');
      }

      const rows = _.map(data, (row) => {
        return _.reduce(
          columnsToInclude,
          (acc, key) => {
            if (key === 'address') {
              const address = _.filter(Object.values(row[key]), (value) => {
                return !!value;
              }).join(' ');
              acc.push(address);
            } else {
              acc.push(row[key]);
            }
            return acc;
          },
          []
        );
      });

      const fileName = `${this.options.objectTypeCode.toLowerCase()}_${this.options.objectID}_delivery_schedule`;
      await downloadCSV(columnsNames, rows, fileName);
    } catch (err) {
      showErrorMessage({
        errorCode: 'downloadError',
        errorTitle: 'Download Error',
        errorMessage: 'An error occurred while downloading Relocation delivery schedule CSV.'
      });
    }
  },

  cleanFormData(data) {
    const self = this;
    const address = data.address;
    Object.keys(address).forEach((key) => {
      address[key] = self.removePunctuation(address[key]);
    });
    data.deliveryPOCName = self.removePunctuation(data.deliveryPOCName);
    data.itPOCName = self.removePunctuation(data.itPOCName);
  },

  removePunctuation(val) {
    if (!val) return;
    return val.replace(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g, '');
  }
});

export default RelocationDeliveryScheduleGridView;
